export default "__VITE_ASSET__zOyQqdNGsn0lL_XEFrarVA__ 480w, __VITE_ASSET__yW_eMvu1QqHghXJHMLbBbg__ 768w, __VITE_ASSET__tgItkVM6JTrfm2CiQnzY5g__ 1280w";